import mixpanel from 'mixpanel-browser';
import { getLocationId, getSwiftCode } from 'helpers/cookies';

//Production mixpanel token
mixpanel.init('d803e2bec1cb5872dc2498bfb6a50ac8');

let env_check = (process.env.NODE_ENV === 'production' && window.location.hostname.includes("web.myshyft.com"));

function locationEventProps(props) {
  const loc_id = getLocationId();
  const swift_code = getSwiftCode();
  const hasLocationId = loc_id != null && loc_id.length > 0;
  const hasSwiftCode = swift_code != null && swift_code.length > 0;

  if (!hasLocationId && !hasSwiftCode) {
    return { eventProps: props, attached: false };
  }

  const next = props != null ? props : {};
  if (hasLocationId) {
    next.location_id = loc_id;
  }
  if (hasSwiftCode) {
    next['Location Code'] = swift_code;
  }
  return { eventProps: next, attached: true };
}

let actions = {
  identify: (id) => {
    if (env_check){ 
        mixpanel.identify(id);
    }else{
        console.log('Mixpanel: identify('+id+')');
    }
  },
  alias: (id) => {
    if (env_check) { 
        mixpanel.alias(id);
    }else{
        console.log('Mixpanel: alias('+id+')');
    }
  },
  track: (name, props) => {
    const { eventProps, attached } = locationEventProps(props);

    if (env_check) {
      try {
        mixpanel.track(name, eventProps);
      } catch (e){
        // console.log('mp error:' + name + ',' + JSON.stringify(props));
      }
    }else if (attached) {
      console.log('Mixpanel: track("'+name+'", '+ JSON.stringify(eventProps) + ')');
    }else{
      console.log('Mixpanel: track("'+name+'")');
    }
  },
  error: (name, props) => {
    if (env_check) {
      try {
        mixpanel.track('Error - ' + name, props);
      } catch (e){
        // console.log('mp error:' + name + ',' + JSON.stringify(props));
      }
    }else{
      if( props != null){
        console.log('Mixpanel: track("Error - '+name+'", '+ JSON.stringify(props) + ')');
      }else{
        console.log('Mixpanel: track("Error - '+name+'")');
      }
    }
  },

  people: {
    set: (props) => {
      if (env_check) {
        mixpanel.people.set(props);
      }else{
        console.log('Mixpanel: people.set(' + JSON.stringify(props) + ')');
      }
    },
  },
  reset: () => {
    if (env_check)  {
      mixpanel.reset();
    }else{
      console.log('Mixpanel: reset()');
    }
  }
};

export let Mixpanel = actions;